<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
  >
    <path
      d="M7.07129 7.07104L21.2134 21.2132"
      stroke="white"
      stroke-width="3"
      stroke-linecap="round"
    />
    <path
      d="M21.3945 7.25244L7.25239 21.3946"
      stroke="white"
      stroke-width="3"
      stroke-linecap="round"
    />
  </svg>
</template>
<script>
export default {
  name: "Close",
};
</script>
